import React from 'react'

const ReviewsSolidIcon = () => {
	return (
		<svg width={30} height={30} viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 17.87V5.65C0 2.5 2.373 0 5.25 0h19.5C27.678 0 30 2.553 30 5.65v12.22c0 3.15-2.373 5.65-5.25 5.65H12.553s-7.303 6.845-7.707 6.465c-.27-.255 1.142-6.524 1.142-6.524l-1.748-.104C1.817 22.868 0 20.587 0 17.87z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ReviewsSolidIcon
